// leverage.js
import HTTP from "@/_helpers/http";
import { GENERALINFO__API } from "@/_helpers/urls";
import { GENERALINFO__MUTATIONS } from "../mutation-types";
import { GENERALINFO__ACTIONS } from "../action-types";
import toast from "@/services/Notification";

// State
const state = {
  generalInfos: [],
};

// Getters
const getters = {};

// Mutations
const mutations = {
  [GENERALINFO__MUTATIONS.GENERALINFO](state, data) {
    state.generalInfos = data;
  },
  updateGeneralInfo(state, { key, value }) {
    if (state.generalInfos.hasOwnProperty(key)) {
      state.generalInfos[key] = value;
    }
  },
};

// Actions
const actions = {
  async [GENERALINFO__ACTIONS.GENERALINFO]({ commit }) {
    try {
      const url = `${GENERALINFO__API.GENERALINFO}`;
      const response = await HTTP().get(url);
      commit(GENERALINFO__MUTATIONS.GENERALINFO, response.data);
    } catch (error) {
      console.log(error);
    }
  },
  async [GENERALINFO__ACTIONS.UPDATEGENERALINFO]({ dispatch }, parameter) {
    try {
      const formData = new FormData();

      const fields = [
        "language",
        "company_name",
        "company_url",
        "company_short_description",
        "ipstack_api_key",
        "client_portal_url",
        "partner_portal_url",
        "admin_portal_url",
        "logo_width",
        "logo_height",
        "favicon_height",
        "favicon_width",
        "login_1st_img_text",
        "login_2nd_img_text",
        "login_3rd_img_text",
        "facebook_link",
        "google_plus_link",
        "twitter_link",
        "youtube_link",
        "linked_in_link",
        "skype_link",
        "viber_link",
        "whatsapp_link",
        "forum_link",
        "footer_link1_text",
        "footer_link1_link",
        "footer_link2_text",
        "footer_link2_link",
        "footer_link3_text",
        "footer_link3_link",
        "footer_link4_text",
        "footer_link4_link",
        "footer_link5_text",
        "footer_link5_link",
        "risk_warning_title",
        "risk_warning_text",
        "legal_information_title",
        "legal_information_text",
        "copyright_text",
        "open_live_account_page_header",
        "open_live_account_page_subheader",
        "open_live_account_page_icon1",
        "open_live_account_page_text1",
        "open_live_account_page_icon2",
        "open_live_account_page_text2",
        "open_live_account_page_icon3",
        "open_live_account_page_text3",
        "open_live_account_page_icon4",
        "open_live_account_page_text4",
        "open_demo_account_page_header",
        "open_demo_account_page_subheader",
        "open_demo_account_page_icon1",
        "open_demo_account_page_text1",
        "open_demo_account_page_icon2",
        "open_demo_account_page_text2",
        "open_demo_account_page_icon3",
        "open_demo_account_page_text3",
        "open_demo_account_page_icon4",
        "open_demo_account_page_text4",
        "register_page_icon1",
        "register_page_text1",
        "register_page_icon2",
        "register_page_text2",
        "register_page_icon3",
        "register_page_text3",
        "register_page_icon4",
        "register_page_text4",
        "live_chat_link",
        "register_page_header",
        "register_page_subheader",
        "phone",
        "address",
      ];

      for (const field of fields) {
        if (parameter[field]) {
          formData.append(field, parameter[field]);
        }
      }

      const fileFields = [
        "logo_url",
        "logo_url_dark",
        "favicon_url",
        "login_1st_img",
        "login_2nd_img",
        "login_3rd_img",
        "register_page_img",
        "open_live_account_page_img",
        "open_demo_account_page_img",
      ];

      for (const fileField of fileFields) {
        if (parameter[fileField]) {
          formData.append(fileField, parameter[fileField]);
        }
      }

      const response = await HTTP().patch(
        GENERALINFO__API.UPDATEGENERALINFO,
        formData
      );

      if (response.status === 200) {
        toast.success("Successfully Updated");
        await dispatch(GENERALINFO__ACTIONS.GENERALINFO);
      }
    } catch (error) {
      console.error("Error updating server config:", error);
    }
  },


  async [GENERALINFO__ACTIONS.UPDATEGENERALINFOLOGO]({ dispatch }, parameter) {
    try {
      const formData = new FormData();
      const fileFields = [
        "logo_url",
        "logo_url_dark",
        "favicon_url",
      ];

      for (const fileField of fileFields) {
        if (parameter[fileField]) {
          formData.append(fileField, parameter[fileField]);
        }
      }

      const response = await HTTP().patch(
        GENERALINFO__API.UPDATEGENERALINFOLOGO,
        formData
      );

      if (response.status === 200) {
        toast.success("Successfully Updated");
        await dispatch(GENERALINFO__ACTIONS.GENERALINFO);
      }
    } catch (error) {
      console.error("Error updating server config:", error);
    }
  },
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};
